import axios from 'axios'

const API_URL = process.env.VUE_APP_AI_AGENT_API_BASE_URL

class ChatService {
  /**
   * Send a message to a chat session
   */
  sendMessage (sessionId, messageData) {
    return axios.post(API_URL + 'chat/sessions/' + sessionId + '/messages', messageData)
  }

  /**
   * Generate session title based on conversation
   */
  generateSessionTitle (sessionId) {
    return axios.post(API_URL + 'chat/sessions/' + sessionId + '/generate-title')
  }

  /**
   * Stream message response (for future implementation)
   */
  async streamMessage (sessionId, messageData, onChunk) {
    // This would use EventSource or WebSocket for streaming
    // For now, we'll use regular POST
    const response = await this.sendMessage(sessionId, { ...messageData, stream: true })
    return response
  }

  /**
   * Cancel ongoing message generation
   */
  cancelMessage (sessionId) {
    // Implement if backend supports cancellation
    return axios.post(API_URL + 'chat/sessions/' + sessionId + '/cancel')
  }
}

export default new ChatService()
